module.exports = __webpack_public_path__ + "img/icon_arrow_up_2.70f854e4.svg";